import { useState } from 'react'
import Alert from "react-bootstrap/Alert"
import { useDispatch, useSelector } from 'react-redux';

import BaseButton from '../../../components/BaseButton';
import BottomBar from '../../../components/BottomBar';
import TitleBar from '../../../components/TitleBar';
import { reissuePassword } from '../slice';
import styles from './styles.module.css'

const ReissuePassword = () => {

  const dispatch = useDispatch();
  const reissuePasswordResult = useSelector((state) => state.reissuePassword);

  const [account_id, setAccount_id] = useState('');
  const [email, setEmail] = useState('');

  let message = null;
  let submitButton = (
    <BaseButton onClick={() => {
      dispatch(reissuePassword(account_id, email))
    }}>
      パスワードを再発行する
      <br />
      Password Reissue
    </BaseButton>
  );

  if (reissuePasswordResult.success) {
    submitButton = (<BaseButton>パスワードを再発行する</BaseButton>);
    message = (
      <Alert variant="info">{reissuePasswordResult.message}</Alert>
    );
  } else {
    if (reissuePasswordResult.message) {
      message = (
        <Alert variant='danger'>{reissuePasswordResult.message}</Alert>
      )
    }
  }

  return (
    <>
      <TitleBar />
      {message}
      <div className={styles.title}>パスワード再発行<br /><div className='en'>Password Reissue</div></div>
      <div className={styles.form}>
        <div className={styles.item}>
          <label htmlFor='account_id' className='form-label'>ユーザーID<br />User ID</label>
          <input id='account_id' type='text' className='form-control'
            onChange={(e) => setAccount_id(e.target.value)} />
        </div>
        <div className={styles.item}>
          <label htmlFor='email' className='form-label'>登録済みメールアドレス<br />Registered Email Address</label>
          <input id='email' type='text' className='form-control'
            onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div>
          <br></br>
          ※ユーザーIDまたはメールアドレスをお忘れの場合、<br></br>
          お問い合わせ画面からパスワードの再発行を依頼してください。
          <br />
          <div className='en'>*If you have forgotten your user ID or email address, please request a password reissue from the Inquiry page.</div>
        </div>
        <div className={styles.item}>
          {submitButton}
        </div>
      </div>
      <BottomBar />
    </>
  );
};

export default ReissuePassword;